module.exports = __webpack_public_path__ + "img/JoeWahba_O_31.b7877260.jpg";